"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DoormatAddress = function DoormatAddress(_ref) {
  var title = _ref.title,
      addressLine1 = _ref.addressLine1,
      addressLine2 = _ref.addressLine2,
      email = _ref.email,
      phone = _ref.phone,
      phoneInfo = _ref.phoneInfo,
      vat = _ref.vat;
  return (0, _preact.h)("address", {
    className: "mtn-m-address"
  }, (0, _preact.h)("div", {
    className: "mtn-m-address__info"
  }, title && (0, _preact.h)("p", {
    className: "mtn-m-address__title"
  }, title), (0, _preact.h)("p", null, addressLine1), (0, _preact.h)("p", null, addressLine2), email && (0, _preact.h)("p", null, (0, _preact.h)("a", {
    className: "mtn-m-address__link",
    href: "mailto:".concat(email)
  }, email))), phone && (0, _preact.h)("p", {
    className: "mtn-m-address__phone"
  }, (0, _preact.h)("a", {
    className: "mtn-m-address__link",
    href: "tel:".concat(phone)
  }, phone), phoneInfo && (0, _preact.h)("span", {
    className: "mtn-m-address__phone-info"
  }, "- ".concat(phoneInfo))), (0, _preact.h)("p", null, vat));
};

var _default = DoormatAddress;
exports["default"] = _default;